import { Routes, Route, Navigate } from "react-router-dom";
import { Meta } from "@/shared/components";
import { useTranslation } from "react-i18next";
import { AnalyticsViewsTab } from "@/partner/features/analytics/ui/AnalyticsViewsTab";
import { AnalyticsSalesTab } from "@/partner/features/analytics/ui/AnalyticsSalesTab";
import { AnalyticsUsersTab } from "@/partner/features/analytics/ui/AnalyticsUsersTab";

export const AnalyticsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Meta title={t("analytics.pageTitle")} pageType="Partner" />
      <Routes>
        <Route path="views" element={<AnalyticsViewsTab />} />
        <Route path="sales" element={<AnalyticsSalesTab />} />
        <Route path="users" element={<AnalyticsUsersTab />} />
        <Route
          path="*"
          element={<Navigate to="/partner/analytics/views" replace />}
        />
      </Routes>
    </>
  );
};
